(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norms-listing-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function showListingReference() {
      const reference = new URLSearchParams(window.location.search).get('listing');
      if (!reference || !/^[a-z0-9-]{1,100}$/.test(reference)) return;
      document.querySelectorAll('[data-nx-listing-inquiry]').forEach((section) => {
        section.querySelector('[data-nx-listing-reference]').textContent = reference;
        section.querySelector('[data-nx-listing-email]').href =
          `mailto:info@normsexchange.com?subject=${encodeURIComponent(`Norms Exchange listing: ${reference}`)}`;
        section.hidden = false;
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showListingReference, { once: true });
    } else {
      showListingReference();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
